export default "/images/fdm.svg?b49d87cc86b703652dda6ca47ff8c180";